// Componente para seção de filtros
import React from "react";
import { PLAGUE_NAMES } from "../utils/constants";
import { MESSAGES } from "../utils/constants";
import style from "../body-dashboard.module.css";

/**
 * Componente FiltersSection - Seção de filtros do Dashboard
 */
const FiltersSection = ({
  municipality,
  plagues,
  showCards,
  enablePlague,
  plagueSelected,
  plots,
  onViewCards,
  onChangeMunicipio,
  onChangePlague
}) => {
  const municipalityOptions = Array.isArray(municipality) && municipality.length > 0
    ? municipality
    : [];

  return (
    <div
      className={style["details"]}
      style={showCards ? {} : { marginBottom: "50px" }}
    >
      <div className={style["text-info"]}>Filtro</div>

      <div className={style["select-container"]}>
        {/* Select de município */}
        <select
          className={style["select"]}
          onChange={onChangeMunicipio}
        >
          <option value="">Escolha um município</option>
          {municipalityOptions.map((municipio, index) => (
            <option key={index} value={municipio}>
              {municipio}
            </option>
          ))}
        </select>

        {/* Select de praga (habilitado após selecionar município) */}
        {enablePlague && (
          <select
            className={style["select"]}
            value={plagueSelected}
            onChange={onChangePlague}
          >
            <option value="">Escolha uma praga</option>
            {PLAGUE_NAMES.map((plague, key) => (
              <option key={key} value={plague.name}>
                {plague.name}
              </option>
            ))}
          </select>
        )}

        {/* Botão de filtrar */}
        <button className={style["button"]} onClick={onViewCards}>
          Filtrar
        </button>
      </div>

      {/* Mensagem quando não há resultados */}
      {showCards && plots && plots.length === 0 && (
        <div className={style["no-result-card"]}>
          {MESSAGES.NO_RESULTS}
        </div>
      )}
    </div>
  );
};

export default FiltersSection;

